module.exports = __webpack_public_path__ + "instruct.51128df0.png";